import { InstitutionalAccountsActions } from './institutional-accounts.actions';

export class InstitutionalAccountsState {
    data: Array<any>;
    pending: boolean;
    error: null;
}

export const initialState: InstitutionalAccountsState = {
    data: [],
    pending: false,
    error: null
}

export function InstitutionalAccountsReducer(state: InstitutionalAccountsState = initialState, { type, payload }){

    switch (type) {

        case InstitutionalAccountsActions.getItems:
            return {...state, ...{ pending: true, error: null }}

        case InstitutionalAccountsActions.getItemsSuccess:
            return {...state, ...{ data: payload, pending: false, error: null }}

        case InstitutionalAccountsActions.getItemsError:
            return {...state, ...{ pending: false, error: payload }}

        default:
            return state;
    }
};
